import { RegistrationType } from 'app/features/manual-input-registration/models/registration-type';
import { Activity } from 'app/shared/features/activity-selector/models/activity';

export interface TimeRegistrationDefinition {
    name: string;
    id: string;
    activity: Activity | undefined;
    registrationType: RegistrationType;
}

export function endBreakActivityToTimeRegistrationDefinition(activity: Activity): TimeRegistrationDefinition {
    return {
        activity,
        name: activity.name,
        id: `end-break-${activity.number}`,
        registrationType: RegistrationType.EndPause,
    };
}

export const loginRegistrationDefinition: TimeRegistrationDefinition = {
    registrationType: RegistrationType.Login,
    id: 'login',
    activity: undefined,
    name: 'LOGIN.TITLE.DEFAULT',
};
export const logoutRegistrationDefinition: TimeRegistrationDefinition = {
    registrationType: RegistrationType.Logout,
    id: 'logout',
    activity: undefined,
    name: 'GENERAL.TITLE.LOGOUT',
};
export const startBreakRegistrationDefinition: TimeRegistrationDefinition = {
    registrationType: RegistrationType.StartPause,
    id: 'start-break',
    activity: undefined,
    name: 'GENERAL.TITLE.START_BREAK',
};
